<ng-container *ngTemplateOutlet="modal ? modalTemplate : integrationsTemplate"></ng-container>

<ng-template #modalTemplate>
    <ng-container *transloco="let translate">
        <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
            <div>
                <span class="text-base" [textContent]="translate('Source System') + ':'"></span>
            </div>
            <material-button [titleText]="'Close'" [prefixIcon]="'close'" [buttonType]="'icon'" [prefixIconType]="'material'" [size]="'small'" (buttonClicked)="closeModal()" class="p-2 rounded-full hover:bg-gray-100 focus:outline-none"></material-button>
        </div>
    </ng-container>
    <mat-dialog-content class="!max-w-full !px-2 !max-h-[70vh] space-y-4 !relative !left-5" *ngIf="record?.recordData">
        <ng-container *ngTemplateOutlet="integrationsTemplate"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]" *transloco="let translate">
        <material-button [classList]="['!w-auto']" class="!mx-2" [text]="translate('Close')" [color]="'default'" (buttonClicked)="closeModal()"></material-button>
        <material-button [classList]="['!w-auto']" class="!mx-2" [text]="inEdit ? translate('Update') : translate('Create')" color="primary" (buttonClicked)="submitConfig()"></material-button>
    </mat-dialog-actions>
</ng-template>

<ng-template #integrationsTemplate>
    <ng-container *transloco="let translate">
        <app-integrations-template [noHeader]="modal" [title]="translate('Authorization System') + ' : ' + config?.sourceSystemName" [record]="record" [config]="configMeta" [openWidget]="drawer?.opened || modal" [drawer]="drawer" [dontFetchUsingMasters]="true" [inConnectorsUI]="true" [translated]="true" (gotoIntegrationsPage)="closeDrawer()"></app-integrations-template>
    </ng-container>
</ng-template>
